module.exports = __webpack_public_path__ + "static/media/file-icon.ef76f536.svg";